import(/* webpackMode: "eager" */ "/vercel/path0/app/item/[id]/(comments)/page.module.css");
import(/* webpackMode: "eager" */ "/vercel/path0/components/comment.js")